import { AddEmployerFormGroup } from '../../../forms/add-employer-form-group';
import { AbstractControl, FormArray, ValidationErrors } from '@angular/forms';

export function atLeastOneSigningAuthorityValidator(control: AbstractControl): ValidationErrors | null {
  const formGroup = control as AddEmployerFormGroup;

  const primaryContact = formGroup.get('primaryContact');
  const additionalContacts = formGroup.get('additionalContacts') as FormArray;

  if (!primaryContact || !additionalContacts) {
    return null;
  }

  const primaryHasAuthority = primaryContact.get('hasSigningAuthority')?.value === true;
  const additionalHasAuthority = additionalContacts.controls.some(
    contact => contact.get('hasSigningAuthority')?.value === true
  );

  const hasAtLeastOne = primaryHasAuthority || additionalHasAuthority;

  if (!hasAtLeastOne) {
    primaryContact.setErrors({
      ...primaryContact.errors,
      noSigningAuthority: true
    });
    return { noSigningAuthority: true };
  } else {
    if (primaryContact.errors?.noSigningAuthority) {
      const { noSigningAuthority, ...remainingErrors } = primaryContact.errors;
      primaryContact.setErrors(Object.keys(remainingErrors).length > 0 ? remainingErrors : null);
    }
    return null;
  }
}
